"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CHANNEL_PLAY_URL_QUERY = exports.GET_CHANNEL_VIDEO_PLAY_URLS_QUERY = exports.GET_CHANNEL_VIDEO_QUERY = exports.GET_VIDEO_QUERY = exports.GET_VIDEOS_QUERY = exports.GET_WIDGET_DATA_QUERY = exports.GET_CHANNEL_QUERY = void 0;
const helpers_1 = require("../../client/helpers");
const fragments_1 = require("./fragments");
exports.GET_CHANNEL_QUERY = `
  query GetChannel($channelId: ID!) {
    channel(filter: { id: $channelId }) {
      ...PublicChannelFragment
      videos {
        total
      }
    }
  }
  ${fragments_1.PUBLIC_CHANNEL_FRAGMENT}
`;
exports.GET_WIDGET_DATA_QUERY = `
  query GetWidgetData(
    $channelId: ID!
    $videosCount: Int
    $cursor: String
    $sort: SortOrder = CUSTOM_DESC
    $query: String
  ) {
    channel(filter: { id: $channelId }) {
      ...PublicChannelFragment
      videos(
        limit: $videosCount
        cursor: $cursor
        sort: $sort
        filter: { query: $query }
      ) {
        total
        cursor
        entities {
          ...PublicVideoFragment
        }
      }
    }
  }
  ${fragments_1.PUBLIC_VIDEO_FRAGMENT}
  ${fragments_1.PUBLIC_CHANNEL_FRAGMENT}
`;
exports.GET_VIDEOS_QUERY = `
  query GetVideos(
    $channelId: ID!
    $limit: Int!
    $cursor: String
    $sort: SortOrder
    $query: String
    $tag: String
    $category: String
  ) {
    channel(filter: { id: $channelId }) {
      videos(
        limit: $limit
        cursor: $cursor
        sort: $sort
        filter: { query: $query, tag: $tag, category: $category }
      ) {
        total
        cursor
        entities {
          ...PublicVideoFragment
        }
      }
    }
  }
  ${fragments_1.PUBLIC_VIDEO_FRAGMENT}
`;
exports.GET_VIDEO_QUERY = `
  query GetVideo($videoId: ID!) {
    video(filter: { id: $videoId }) {
      ...PublicVideoFragment
    }
  }
  ${fragments_1.PUBLIC_VIDEO_FRAGMENT}
`;
exports.GET_CHANNEL_VIDEO_QUERY = `
  query GetChannelVideo($channelId: ID!, $videoId: ID!) {
    channel(filter: { id: $channelId }) {
      video(filter: { id: $videoId }) {
        ...PublicVideoFragment
      }
    }
  }
  ${fragments_1.PUBLIC_VIDEO_FRAGMENT}
`;
exports.GET_CHANNEL_VIDEO_PLAY_URLS_QUERY = `
  query GetChannelVideoPlayUrls($videoId: ID!, $channelId: ID!) {
    channel(filter: { id: $channelId }) {
      video(filter: { id: $videoId }) {
        download(type: CONTENT) {
          entity {
            url
          }
        }
        play(type: CONTENT) {
          # //TODO remove type
          entity {
            hls
          }
        }
      }
    }
  }
`;
exports.GET_CHANNEL_PLAY_URL_QUERY = `
  query GetChannelPlayUrl($channelId: ID!) {
    channel(filter: { id: $channelId }) {
      play(type: TRAILER) {
        entity {
          hls
        }
      }
    }
  }
`;
//# sourceMappingURL=queries.js.map